import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.BasketballBinary.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.BasketballBinary.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.ball = null;
  this.sentence = [];
};

EDC.Games.BasketballBinary.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.BasketballBinary.Scenes.Main.prototype.constructor = EDC.Games.BasketballBinary.Scenes.Main;

const SOQ = EDC.Games.BasketballBinary.Scenes.Main.prototype;

SOQ.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

SOQ.createTemplateUI = function () {
  this.addTitle();
  this.addChoices();
  this.add.sprite(960, 1000, 'frame').setScale(0.9);
};

SOQ.loadIteration = function () {
  this.addBall();
  this.addSentence();
};

SOQ.nextIteration = function () {
  this.ball.destroy();
  this.ball = null;
  this.sentence.map((x) => {
    x.destroy();
    return true;
  });
  this.sentence = [];
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

SOQ.addSentence = function () {
  const font = {
    font: `76px ${this.gameConfig.font}`,
  };
  const font2 = {
    font: `50px ${this.gameConfig.font}`,
  };
  let text = this.add
    .text(0, 975, this.gameConfig.sets[this.difficulty].iterations[this.iteration].sentence, font)
    .setDepth(1);
  if (text.displayWidth > 1450) {
    text.destroy();
    text = this.add
      .text(0, 975,
        this.gameConfig.sets[this.difficulty].iterations[this.iteration].sentence, font2)
      .setDepth(1);
  }
  text.x = (this.game.config.width - text.displayWidth) / 2;
  text.setTint(0xffff00);

  this.sentence.push(text);
};

SOQ.addBall = function () {
  this.ball = this.add.sprite(940, 720, 'ball');
  this.ballFloat();
  this.ball.isRolling = false;
  const rect = new Phaser.Geom.Rectangle(0, 0, 200, 200);
  this.ball.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
  this.cursorManager.setDefaultDraggableEvents(this.ball);
  this.input.setDraggable(this.ball);
  this.ball.on(
    'drag',
    ((sprite, pointer, x, y) => {
      sprite.setPosition(x, y);
    }).bind(this, this.ball),
  );

  this.ball.on('dragend', this.onDragStop.bind(this, this.ball), this);
  this.ball.on('dragstart', this.onDragstart.bind(this, this.ball), this);
};

SOQ.ballFloat = function () {
  const tween = this.tweens.add({
    targets: this.ball,
    y: this.ball.y - 20,
    duration: 1000,
    ease: 'Sine.easeInOut',
    repeat: -1,
    yoyo: true,
  });
};

SOQ.onDragstart = function (dragObj, pointer) {
  this.tweens.killTweensOf(dragObj);
};

SOQ.onDragStop = function (dragObj, pointer) {
  let side;
  if (dragObj.x < 700) {
    side = 1;
    // dragObj.x = 450;
    // dragObj.y = 550;
    this.checkAnswer(side);
  } else if (dragObj.x > 1150) {
    side = 2;
    // dragObj.x = 1500;
    // dragObj.y = 550;
    this.checkAnswer(side);
  } else {
    dragObj.x = 940;
    dragObj.y = 720;
    this.ballFloat();
  }
};

SOQ.checkAnswer = function (side) {
  this.ball.disableInteractive();
  const answer = side;
  // eslint-disable-next-line max-len
  const correctAnswer = this.gameConfig.sets[this.difficulty].iterations[this.iteration].correctAnswer;
  if (answer === correctAnswer) {
    this.playCorrect();
    this.tweens.add({
      targets: this.ball,
      alpha: 0,
      duration: 500,
      delay: 100,
      ease: 'Linear',
      onComplete: this.bounceAnimation.bind(this, side, false),
    });
  } else {
    this.playWrong();
    this.ball.setTint(0xff0000);
    this.tweens.add({
      targets: this.ball,
      alpha: 0,
      duration: 500,
      delay: 100,
      ease: 'Linear',
      onComplete: this.bounceAnimation.bind(this, side, true),
    });
  }
};

SOQ.bounceAnimation = function (side, isWrong) {
  this.ball.x = 940;
  this.ball.y = 720;
  this.ball.isRolling = true;
  this.goAboveNet(side, isWrong);
};

SOQ.update = function () {
  if (this.ball) {
    if (this.ball.isRolling) {
      this.ball.angle += 1;
    }
  }
};

SOQ.goAboveNet = function (side, isWrong) {
  this.ball.setAlpha(1);
  if (isWrong) {
    if (side === 1) {
      this.tweens.add({
        targets: this.ball,
        x: 360,
        y: 350,
        duration: 500,
        delay: 350,
        ease: 'Back.easeOut',
        onComplete: this.goInsideNet.bind(this, side, isWrong),
      });
    } else {
      this.tweens.add({
        targets: this.ball,
        x: 1550,
        y: 350,
        duration: 500,
        delay: 350,
        ease: 'Back.easeOut',
        onComplete: this.goInsideNet.bind(this, side, isWrong),
      });
    }
    return;
  }
  if (side === 1) {
    this.tweens.add({
      targets: this.ball,
      x: 360,
      y: 345,
      duration: 500,
      delay: 350,
      ease: 'Back.easeOut',
      onComplete: this.goInsideNet.bind(this, side, isWrong),
    });
  } else {
    this.tweens.add({
      targets: this.ball,
      x: 1550,
      y: 345,
      duration: 500,
      delay: 350,
      ease: 'Back.easeOut',
      onComplete: this.goInsideNet.bind(this, side, isWrong),
    });
  }
};

SOQ.goInsideNet = function (side, isWrong) {
  if (isWrong) {
    this.tweens.add({
      targets: this.ball,
      x: 940,
      y: 720,
      duration: 500,
      delay: 150,
      ease: 'Back.easeOut',
      onComplete: this.flyBack.bind(this),
    });
    return;
  }
  this.time.addEvent({ delay: 2000, callback: this.nextIteration, callbackScope: this });
  if (side === 1) {
    const shape = this.make.graphics().fillRect(230, 452, 270, 270);
    const geomask = shape.createGeometryMask();
    geomask.invertAlpha = true;
    this.ball.setMask(geomask);
    this.tweens.add({
      targets: this.ball,
      y: 570,
      duration: 550,
      delay: 200,
      ease: 'Sine.easeInOut',
      onComplete: this.starsAnim.bind(this, side),
    });
  } else {
    const shape = this.make.graphics().fillRect(1410, 445, 270, 270);
    const geomask = shape.createGeometryMask();
    geomask.invertAlpha = true;
    this.ball.setMask(geomask);
    this.tweens.add({
      targets: this.ball,
      y: 570,
      duration: 550,
      delay: 200,
      ease: 'Sine.easeInOut',
      onComplete: this.starsAnim.bind(this, side),
    });
  }
};

SOQ.starsAnim = function (side) {
  this.ball.isRolling = false;
  const randomKey = Math.random() * 100;
  const star = this.add.sprite(this.ball.x, this.ball.y - 150, 'star-explode').setScale(2.5);
  star.setFrame(0);
  this.anims.create({
    key: randomKey,
    frames: this.anims.generateFrameNumbers('star-explode'),
    frameRate: 7,
    hideOnComplete: true,
  });
  star.play(randomKey);
};

SOQ.flyBack = function () {
  this.ball.isRolling = false;
  this.ball.clearTint();
  this.tweens.add({
    targets: this.ball,
    x: 940,
    y: 720,
    duration: 400,
    ease: 'Sine.easeInOut',
  });
  this.ball.setInteractive();
};

SOQ.addChoices = function () {
  const choiceFont = {
    font: `56px ${this.gameConfig.font}`,
  };
  const instructionsFont = {
    font: `66px ${this.gameConfig.font}`,
  };
  const choice1 = this.add.text(190, 370, this.gameConfig.choice1, choiceFont).setTint(0xffff00);
  const choice2 = this.add.text(1400, 370, this.gameConfig.choice2, choiceFont).setTint(0xffff00);
  const instructions = this.add.text(0, 850,
    this.gameConfig.instructionsTxt, instructionsFont).setTint(0xffff00);
  instructions.x = (this.game.config.width - instructions.displayWidth) / 2;
};

SOQ.addTitle = function () {
  const font = {
    font: `100px ${this.gameConfig.font}`,
  };
  const title = this.add.text(0, 130, this.gameConfig.titleTxt, font).setDepth(1);
  title.x = (this.game.config.width - title.displayWidth) / 2;
  title.setTint(0xffff00);
};

export default EDC.Games.BasketballBinary.Scenes.Main;
